import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom';
import ReactStars from "react-rating-stars-component";
import Loader from '../../../layout/loader'
import './realtedPproducts.css'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import fallbackProductImage from '../../../images/not_found_product.png';

import {textRapForNameSearch} from '../../../utils/textRapUtils'

function RealtedBrand({ loading, realtedBrand }) {
  const history = useHistory();

  const realtedPageHandler = (id) => {
    history.push(`/ProductDetail/${id}`)
  }

  return (
    <Fragment>
      {loading ? <Loader /> : (<Fragment>
        {realtedBrand && realtedBrand.slice(0, 10).map((realtedBrand, index) => (
          <div className="realted-brand-pro-container" key={realtedBrand._id || index}>
            <div className="realted-brand-pro">
              <button className="realted-brand-image-button" onClick={() => realtedPageHandler(realtedBrand._id)}>
                {realtedBrand.mainImage && realtedBrand.mainImage[0] && realtedBrand.mainImage[0].imageurl ? (
                  <img
                    src={realtedBrand.mainImage[0].imageurl}
                    alt={realtedBrand.name}
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = fallbackProductImage;
                    }}
                  />
                ) : (
                  <span>No image</span>
                )}
              </button>
              <div className="realted-brand-descripation">
                <span>{realtedBrand.tag || realtedBrand.brandName || 'Same brand'}</span>
                <div className="bestSeller-Star">
                  <ReactStars edit={false}
                    color='gray'
                    activeColor='#ffd700'
                    size={window.innerWidth < 600 ? 20 : 30}
                    value={realtedBrand.ratings}
                    isHalf={true} />
                </div>
                <h3 onClick={() => realtedPageHandler(realtedBrand._id)} >  {textRapForNameSearch(realtedBrand.name)}   </h3>
                <p><span><CurrencyRupeeIcon /></span><span>{realtedBrand.price}</span></p>
              </div>
              <button className="realted-brand-action" onClick={() => realtedPageHandler(realtedBrand._id)}>
                View Pair <ShoppingBagOutlinedIcon />
              </button>
            </div>
          </div>))}
      </Fragment>)}
    </Fragment>
  )
}

export default RealtedBrand
